import {
    ErrorSource,
    ErrorSeverity,
    ErrorCategory,
    ErrorClassification,
} from './errors.interfaces';

const ERROR_PATTERNS = {
    scriptError: {
        message: 'script error',
    },
    thirdParty: {
        sanity_cms: ['sanity'],
        awin_tracking: ['awin'],
        websocket: ['websocket', 'scheme must be'],
        sentry: ['permission denied to access property'],
    },
    cartEmpty: ['kundvagnen', 'shopping cart'],
    network: [
        'network error',
        'request aborted',
        'timeout exceeded',
        'load failed',
        'failed to fetch',
        'axioserror',
    ],
    amelia: ['chat-widget', 'z.data.chat'],
} as const;

function isCrossOriginError(message: string): boolean {
    return message.includes(ERROR_PATTERNS.scriptError.message);
}

function isThirdPartyError(message: string): { isThirdParty: boolean; service?: string } {
    for (const [service, patterns] of Object.entries(ERROR_PATTERNS.thirdParty)) {
        if (patterns.some((pattern) => message.includes(pattern))) {
            return { isThirdParty: true, service };
        }
    }
    return { isThirdParty: false };
}

function isCartEmptyError(message: string): boolean {
    return ERROR_PATTERNS.cartEmpty.some((pattern) => message.includes(pattern));
}

function isNetworkError(message: string): boolean {
    return ERROR_PATTERNS.network.some((pattern) => message.includes(pattern));
}

function isAmeliaError(message: string): boolean {
    return ERROR_PATTERNS.amelia.some((pattern) => message.includes(pattern));
}

export function classifyError(message: string): ErrorClassification {
    const errorMessage = message.toString().toLowerCase() || '';

    if (isCrossOriginError(errorMessage)) {
        return {
            source: ErrorSource.CrossOrigin,
            severity: ErrorSeverity.P2,
            errorCategory: ErrorCategory.ThirdParty,
            shouldTrack: true,
        };
    }

    const thirdParty = isThirdPartyError(errorMessage);
    if (thirdParty.isThirdParty) {
        return {
            source: ErrorSource.ThirdParty,
            severity: ErrorSeverity.P2,
            errorCategory: ErrorCategory.ThirdParty,
            shouldTrack: true,
            component: thirdParty.service,
        };
    }

    if (isNetworkError(errorMessage)) {
        return {
            source: ErrorSource.Network,
            severity: ErrorSeverity.P1,
            errorCategory: ErrorCategory.Network,
            shouldTrack: true,
        };
    }

    if (isCartEmptyError(errorMessage)) {
        return {
            source: ErrorSource.Application,
            severity: ErrorSeverity.P1,
            errorCategory: ErrorCategory.CartEmpty,
            shouldTrack: true,
        };
    }

    if (isAmeliaError(errorMessage)) {
        return {
            source: ErrorSource.Application,
            severity: ErrorSeverity.P1,
            errorCategory: ErrorCategory.Amelia,
            shouldTrack: true,
        };
    }

    return {
        source: ErrorSource.Application,
        severity: ErrorSeverity.P1,
        errorCategory: ErrorCategory.Other,
        shouldTrack: true,
    };
}
